import { compact, filter, orderBy, reduce, keys } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getI18nOrLabel } from 'utils/StringUtil'
import { ALL } from '../../../administration/components/user/constants/ApplicationHabilitationConstants'
import DtoApplicationHabilitation from '../../../administration/components/user/dto/DtoApplicationHabilitation'
import DtoUser from '../../../administration/components/user/dto/DtoUser'
import { getStationTypeFromUserConstants } from '../../../utils/StationUtils'
import DtoAccountHabilitation from '../../dto/DtoAccountHabilitation'
import { Card, CardContent, Grid } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import { darkBlue } from 'utils/constants/ColorTheme'
import DoneIcon from '@mui/icons-material/Done'
import CancelIcon from '@mui/icons-material/Cancel'
import { GREEN, RED } from 'components/constants/ColorConstant'

class ModulesAccountPanel extends Component {
    constructor(props) {
        super(props)
    }

    getIcon = (hasHabilitation = false) => hasHabilitation ? <DoneIcon sx={{ color: GREEN, fontSize: 24 }}/> : <CancelIcon sx={{ color: RED, fontSize: 24 }}/>

    getValue = (value) => this.props.accountHabilitations.some(hab => hab.habilitation === value)

    getData = () => {
        const filterHabilitations = filter(this.props.applicationHabilitations, (o) => {
            return !o.parameter.includes(`_${ALL}`)
        })
        const reduceHabilitations = reduce(filterHabilitations, (a, b) => {
            (a[b.habilitationType] || (a[b.habilitationType] = [])).push(b)
            return a
        }, {})

        const finalList = orderBy(keys(reduceHabilitations).map((b) => {
            return {
                parameter: b,
                title: getI18nOrLabel(getStationTypeFromUserConstants(b)),
                data: reduceHabilitations[b],
            }
        }), (o) => o.data.length, 'asc')

        return finalList.map((b) => {
            const hasHabilitation = this.getValue(b.parameter)
            const result = b.data.map((o) => {
                if (!o.title) {
                    return null
                }
                const icon = this.getIcon(hasHabilitation)
                return (
                    <Grid key={o.title} container>
                        <Grid size={1}>
                            {icon}
                        </Grid>
                        <Grid size={11}>
                            { getI18nOrLabel(o.title) }
                        </Grid>
                    </Grid>
                )
            })
            return (
                <Grid key={b.title} size={4}>
                    <Card>
                        <CardTitle color={darkBlue} title={b.title} centerTitle/>
                        {compact(result).length > 0 && <CardContent>{result}</CardContent>}
                    </Card>
                </Grid>
            )
        })
    }

    render() {
        if (this.props.accountHabilitations.length) {
            return (
                <Grid container columnSpacing={2}>
                    { this.getData() }
                </Grid>
            )
        }
        return null
    }
}

ModulesAccountPanel.propTypes = {
    accountUser: PropTypes.instanceOf(DtoUser),
    accountHabilitations: PropTypes.arrayOf(PropTypes.instanceOf(DtoAccountHabilitation)),
    applicationHabilitations: PropTypes.arrayOf(PropTypes.instanceOf(DtoApplicationHabilitation)),
}

const mapStateToProps = (store) => {
    return {
        accountUser: store.AccountReducer.accountUser,
        accountHabilitations: store.AccountReducer.accountHabilitations,
        applicationHabilitations: store.UserReducer.applicationHabilitations,
    }
}
export default connect(mapStateToProps)(ModulesAccountPanel)
